import React, { useEffect, useState } from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import HistoryComponent from './HistoryComponent';
import { collection, getDocs, query, where } from 'firebase/firestore/lite';
import { firebaseFireStore } from '../../config/firebaseFirestore';

export default function HistoryTab(props) {
  const [nftHis, setnftHis] = useState([]);
  const [loading, setloading] = useState(false);

  useEffect(() => {
    if (props.nftData) {
      getNftHistory();
    }
  }, [props.nftData]);

  const getNftHistory = async () => {
    setloading(true);
    let snap;
    if (props.isMultiple) {
      snap = await getDocs(
        query(
          collection(
            firebaseFireStore,
            'musicartNfts',
            props.nftData.tokenId,
            'nftHistory',
          ),
          where('nftId', '==', props.nftData.nftId),
        ),
      );
    } else {
      // console.log("runn his");
      snap = await getDocs(
        collection(
          firebaseFireStore,
          'musicartNfts',
          props.nftData.tokenId,
          'nftHistory',
        ),
      );
    }

    if (snap.empty) {
      setloading(false);
      return null;
    }

    let nftHisLArr = [];
    let mintedArr = [];
    snap.forEach((doc) => {
      if (doc.data().type && doc.data().type === 'MINT') {
        mintedArr.push(doc.data());
      } else {
        nftHisLArr.push(doc.data());
      }
    });
    nftHisLArr.sort(function (a, b) {
      return Number(b.timestamp) - Number(a.timestamp);
    });
    mintedArr.sort(function (a, b) {
      return Number(b.index) - Number(a.index);
    });
    setnftHis(nftHisLArr.concat(mintedArr));
    setloading(false);
  };

  return (
    <div className="nft__tab_pane nft__tab__pane--scroll" role="tabpanel">
      <div className="nft__tab_content">
        {nftHis.map((ele, index) => {
          return <HistoryComponent ele={ele} nftData={props.nftData} />;
        })}

        {(() => {
          if (!loading && (!nftHis || nftHis.length === 0)) {
            return <p className="text-center ">No record found</p>;
          }
        })()}
        {loading && (
          <div className="flex justify-center	w-full my-6  mx-6">
            <Skeleton animation="wave" height={20} width="60%" />
          </div>
        )}
      </div>
    </div>
  );
}
